/**
 * Las partidas que se pueden quitar de una cotizacion, y la lista de las ya quitadas
 * para volver a ponerlas. Los equipos principales (panel, inversor, bateria) no se
 * quitan: sin ellos el sistema que se analiza ya no seria el que se cotiza. El motor
 * vuelve a comprobarlo; esto solo decide que botones se dibujan.
 */

export const NOMBRE_PARTIDA: Record<string, string> = {
  pv_box: 'Caja de protección PV',
  herrajes: 'Herrajes y montaje',
  cable_pv: 'Cable fotovoltaico',
  conector_mc4: 'Conectores MC4',
  materiales_electricos: 'Materiales eléctricos',
  instalacion: 'Instalación',
  instalacion_manual: 'Instalación',
  transporte: 'Transporte y viáticos',
  estudio_cargas: 'Estudio de cargas',
}

export const PARTIDAS_QUITABLES: ReadonlySet<string> = new Set(Object.keys(NOMBRE_PARTIDA))

interface Props {
  excluir: string[]
  alRestaurar: (codigo: string) => void
}

export function PartidasQuitadas({ excluir, alRestaurar }: Props) {
  if (excluir.length === 0) return null
  return (
    <div className="tarjeta partidas-quitadas">
      <strong>Partidas quitadas:</strong>{' '}
      {excluir.map((c) => (
        <button type="button" key={c} className="chip" onClick={() => alRestaurar(c)} title="Volver a ponerla">
          {NOMBRE_PARTIDA[c] ?? c} ↺
        </button>
      ))}
      <small className="ayuda">Los totales y el análisis ya se calcularon sin ellas.</small>
    </div>
  )
}
